import React, { useState, useEffect, useRef } from "react";
import "./Financials.css";
import KeyStatistics from "./KeyStatistics";
import IncomeStatement from "./IncomeStatement";
import BalanceSheet from "./BalanceSheet";
import CashFlow from "./CashFlow";
import Ratios from "./Ratios";
import FinancialTabs from "./FinancialGiqTabs";
import FinancialStatement from "./FinancialStatement";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
import { useUser } from "../../../../context/UserContext";
import APP_CONFIG from "../../../../config/appConfig";
import FutureBets from "../CompetitorTabs/OrgStructure/FutureBets";
import { useLocation, useParams } from "react-router-dom";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
  getTabType,
  getAllSubdimensionMatches,
  getAllDynamicSubdimensionMatches,
  getVendorCompanyId,
  hasData,
} from "../../../../services/commonService";
import useDynamicSubtabs from "../../../../hooks/useDynamicSubtabs";
import useActiveScrollSection from "../../../../hooks/useActiveScrollSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchSelfFinancialsGiqRequest } from "../../../../store/features/actions/selfFinancialsGiqActions";
import NoDataComp from "../../genericComponents/uiElements/NoDataComp";
import { submitCompetitorProfileV3Request } from "../../../../store/features/actions/competitorProfileV3Actions";
import DocumentsV3 from "../CompetitorTabs/ProfileFinancials/DocumentsV3";
import RevenueAnalysis from "../RevenueAnalysis";
import { fetchRevenueAnalysisRequest } from "../../../../store/features/actions/fetchRevenueAnalysisAction";
import { fetchReGeoWisevenueAnalysisRequest } from "../../../../store/features/actions/fetchGeoWiseRevenueAnalysisAction";
import { getSandPCompanyDetails } from "../../../../services/accIqService";
import StrategicLeadershipThemes from "../CompetitorTabs/OrgStructure/StrategicLeadershipThemes";
import * as FeatherIcon from "react-feather";

export default function FinancialsGiq({
  activeSubKey,
  setActiveSubKey,
  dataReportCheck,
  competitorInfo,
  scrollTarget,
  existingSubdimensions,
  subdimensionStatus,
  registerDynamicTabs,
  scrollContainerRef,
}) {
  const { user } = useUser();
  const strategicLeadershipThemesRef = useRef(null);
  const financialTablesRef = useRef(null);
  const futureBetsLeadershipLedInitiativesFRef = useRef(null);
  const financialDocumentsRef = useRef(null);
  const programmaticScrollRef = useRef(false);
  const dynamicRefs = useRef({});
  const sectionMap = {
    strategicLeadershipThemesTab: strategicLeadershipThemesRef,
    financialsTable: financialTablesRef,
    futureBetsLeadershipLedInitiativesTabf:
      futureBetsLeadershipLedInitiativesFRef,
    financialDocuments: financialDocumentsRef,
  };

  // useActiveScrollSection(
  //   sectionMap,
  //   activeSubKey,
  //   setActiveSubKey,
  //   programmaticScrollRef
  // );
  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef
  );

  const subdimensionExists = (key) => {
    if (!existingSubdimensions || existingSubdimensions.length === 0) {
      return true; // fallback if backend doesn't send list
    }

    return existingSubdimensions.includes(key);
  };

  const subdimensionEnabled = (key) => {
    if (!subdimensionStatus) return true;

    return subdimensionStatus[key] !== false;
  };

  const [dynamicSubdimension, setDynamicSubdimension] = useState([]);
  useDynamicSubtabs({
    parentKey: "financials",
    sourceData: dynamicSubdimension,
    registerDynamicTabs,
    keyPrefix: "dynamic_financials",
  });

  // const scrollToSection = (key) => {
  //   const ref = sectionMap[key];
  //   if (!ref?.current) return;

  //   programmaticScrollRef.current = true;

  //   const yOffset = -100;
  //   const y =
  //     ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

  //   window.scrollTo({ top: y, behavior: "smooth" });

  //   setTimeout(() => {
  //     programmaticScrollRef.current = false;
  //   }, 700);
  // };

  const scrollToSection = (key) => {
    const staticRef = sectionMap[key];

    if (staticRef?.current) {
      staticRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      return;
    }

    const dynamicEl = dynamicRefs.current[key];

    if (dynamicEl) {
      dynamicEl.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    }
  };

  const { account_info } = useSelector((state) => state?.accountsReducer);
  const [activeTab, setActiveTab] = useState("profit_loss");
  const { clientName, competitorName } = useParams();
  const { accountId, accountName } = useParams();
  const [futureBets, setFutureBets] = useState([]);
  const [strategicLeadershipThemes, setStrategicLeadershipThemes] = useState(
    []
  );
  const [financialsDataCheck, setFinancialsDataCheck] = useState({
    hasFinancialsTableData: true,
    hasFutureBetsLeadershipLedInitiativesTabfData: true,
    hasFinancialDocumentsData: true,
    hasStrategicLeadershipThemesTabData: true,
  });

  const vendorCompanyIdGlobal = getVendorCompanyId(competitorInfo);
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = {};
  pageParsedData.query_params.tab = "documents";
  var tab_name = getTabType("documents") || "";
  const dispatch = useDispatch();

  let identifier = "";
  if (competitorName === "Henkel") {
    identifier = "HEN3";
  } else if (competitorName === "United Imaging Healthcare") {
    identifier = "688271:SHSE";
  } else if (competitorName === "Covestro AG") {
    identifier = "1COV";
  } else if (competitorName === "Johnson & Johnson MedTech") {
    identifier = "JNJ";
    // JNJ:NYSE
  } else if (competitorName === "Zimmer Biomet") {
    identifier = "ZBH";
  }

  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, []);

  useEffect(() => {
    // if (identifier) {
    // dispatch(fetchSelfFinancialsGiqRequest({ identifier: identifier }));
    // if (competitorName === "Schaeffler Technologies AG & Co. KG") {
    //   //ASKED BY KAUSHIK
    //   // dispatch(fetchSelfFinancialsGiqRequest({ competitor: "Schaeffler AG" }));
    //   dispatch(
    //     fetchSelfFinancialsGiqRequest({ identifier: vendorCompanyIdGlobal })
    //   );
    // } else {
    // dispatch(fetchSelfFinancialsGiqRequest({ competitor: competitorName }));
    dispatch(
      fetchSelfFinancialsGiqRequest({ identifier: vendorCompanyIdGlobal })
    );
    // }
    // }
  }, []);

  const { records, recordsLoading, recordsError } = useSelector(
    (state) => state?.selfFinancialsGiqReducer
  );

  // ++++++++++++++++++++++++++++++++++++++++++++++++++
  // DATA LOADING FOR FUTURE BETS
  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  const formData = {
    dimension: "OrgStructure",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
    user_id: user?.user_id,
    user_role: user?.growth_iq_role_name,
    user_type:
      user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
  };

  useEffect(() => {
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);
  // ++++++++++++++++++++++++++++++++++++++++++++++++++

  // const recordsLoading = false;
  // const recordsError = null;
  // const records = {
  //   key_statistics: [
  //     {
  //       _id: "IQ_TOTAL_REV",
  //       data: [
  //         { year: 2019, value: 800 },
  //         { year: 2020, value: 850 },
  //         { year: 2021, value: 920 },
  //         { year: 2022, value: 980 },
  //         { year: 2023, value: 1050 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_NI", // Net Income
  //       data: [
  //         { year: 2019, value: 120 },
  //         { year: 2020, value: 140 },
  //         { year: 2021, value: 160 },
  //         { year: 2022, value: 175 },
  //         { year: 2023, value: 190 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_EBITDA",
  //       data: [
  //         { year: 2019, value: 250 },
  //         { year: 2020, value: 280 },
  //         { year: 2021, value: 310 },
  //         { year: 2022, value: 330 },
  //         { year: 2023, value: 350 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_EBIT",
  //       data: [
  //         { year: 2019, value: 200 },
  //         { year: 2020, value: 220 },
  //         { year: 2021, value: 250 },
  //         { year: 2022, value: 270 },
  //         { year: 2023, value: 300 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_DILUT_EPS_INCL",
  //       data: [
  //         { year: 2019, value: 1.5 },
  //         { year: 2020, value: 1.7 },
  //         { year: 2021, value: 2.1 },
  //         { year: 2022, value: 2.5 },
  //         { year: 2023, value: 2.9 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_MARKETCAP*",
  //       data: [
  //         { year: 2019, value: 45000 },
  //         { year: 2020, value: 48000 },
  //         { year: 2021, value: 50000 },
  //         { year: 2022, value: 55000 },
  //         { year: 2023, value: 60000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_ASSETS",
  //       data: [
  //         { year: 2019, value: 70000 },
  //         { year: 2020, value: 73000 },
  //         { year: 2021, value: 76000 },
  //         { year: 2022, value: 80000 },
  //         { year: 2023, value: 85000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_LIAB",
  //       data: [
  //         { year: 2019, value: 30000 },
  //         { year: 2020, value: 32000 },
  //         { year: 2021, value: 35000 },
  //         { year: 2022, value: 37000 },
  //         { year: 2023, value: 40000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_COMMON",
  //       data: [
  //         { year: 2019, value: 15000 },
  //         { year: 2020, value: 16000 },
  //         { year: 2021, value: 17000 },
  //         { year: 2022, value: 18000 },
  //         { year: 2023, value: 20000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CAPEX",
  //       data: [
  //         { year: 2019, value: -5000 },
  //         { year: 2020, value: -4800 },
  //         { year: 2021, value: -5100 },
  //         { year: 2022, value: -5300 },
  //         { year: 2023, value: -5500 },
  //       ],
  //     },
  //   ],

  //   profit_loss: [
  //     {
  //       _id: "IQ_REV",
  //       data: [
  //         { year: 2019, value: 850 },
  //         { year: 2020, value: 920 },
  //         { year: 2021, value: 1050 },
  //         { year: 2022, value: 1200 },
  //         { year: 2023, value: 1350 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_COGS",
  //       data: [
  //         { year: 2019, value: -400 },
  //         { year: 2020, value: -420 },
  //         { year: 2021, value: -460 },
  //         { year: 2022, value: -500 },
  //         { year: 2023, value: -540 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_GP",
  //       data: [
  //         { year: 2019, value: 450 },
  //         { year: 2020, value: 500 },
  //         { year: 2021, value: 590 },
  //         { year: 2022, value: 700 },
  //         { year: 2023, value: 810 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_SGA",
  //       data: [
  //         { year: 2019, value: -150 },
  //         { year: 2020, value: -160 },
  //         { year: 2021, value: -170 },
  //         { year: 2022, value: -200 },
  //         { year: 2023, value: -220 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_RD_EXP",
  //       data: [
  //         { year: 2019, value: -80 },
  //         { year: 2020, value: -90 },
  //         { year: 2021, value: -100 },
  //         { year: 2022, value: -120 },
  //         { year: 2023, value: -140 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_OPER_INC",
  //       data: [
  //         { year: 2019, value: 210 },
  //         { year: 2020, value: 250 },
  //         { year: 2021, value: 320 },
  //         { year: 2022, value: 380 },
  //         { year: 2023, value: 450 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_INTEREST_EXP",
  //       data: [
  //         { year: 2019, value: -20 },
  //         { year: 2020, value: -25 },
  //         { year: 2021, value: -30 },
  //         { year: 2022, value: -28 },
  //         { year: 2023, value: -35 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_EBT",
  //       data: [
  //         { year: 2019, value: 190 },
  //         { year: 2020, value: 230 },
  //         { year: 2021, value: 290 },
  //         { year: 2022, value: 350 },
  //         { year: 2023, value: 415 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_INC_TAX",
  //       data: [
  //         { year: 2019, value: -50 },
  //         { year: 2020, value: -60 },
  //         { year: 2021, value: -70 },
  //         { year: 2022, value: -80 },
  //         { year: 2023, value: -90 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_NI",
  //       data: [
  //         { year: 2019, value: 140 },
  //         { year: 2020, value: 170 },
  //         { year: 2021, value: 220 },
  //         { year: 2022, value: 270 },
  //         { year: 2023, value: 325 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_BASIC_EPS_INCL",
  //       data: [
  //         { year: 2019, value: 1.2 },
  //         { year: 2020, value: 1.5 },
  //         { year: 2021, value: 1.9 },
  //         { year: 2022, value: 2.3 },
  //         { year: 2023, value: 2.8 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_DILUT_EPS_INCL",
  //       data: [
  //         { year: 2019, value: 1.1 },
  //         { year: 2020, value: 1.4 },
  //         { year: 2021, value: 1.8 },
  //         { year: 2022, value: 2.2 },
  //         { year: 2023, value: 2.6 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_DIV_SHARE",
  //       data: [
  //         { year: 2019, value: 0.3 },
  //         { year: 2020, value: 0.35 },
  //         { year: 2021, value: 0.4 },
  //         { year: 2022, value: 0.45 },
  //         { year: 2023, value: 0.5 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_PAYOUT_RATIO",
  //       data: [
  //         { year: 2019, value: 25 },
  //         { year: 2020, value: 23 },
  //         { year: 2021, value: 21 },
  //         { year: 2022, value: 20 },
  //         { year: 2023, value: 18 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_FILINGDATE_IS",
  //       data: [
  //         { year: 2019, value: "2019-03-31" },
  //         { year: 2020, value: "2020-03-31" },
  //         { year: 2021, value: "2021-03-31" },
  //         { year: 2022, value: "2022-03-31" },
  //         { year: 2023, value: "2023-03-31" },
  //       ],
  //     },
  //   ],

  //   balance_sheet: [
  //     {
  //       _id: "IQ_CASH_EQUIV",
  //       data: [
  //         { year: 2019, value: 12000 },
  //         { year: 2020, value: 15000 },
  //         { year: 2021, value: 17000 },
  //         { year: 2022, value: 14000 },
  //         { year: 2023, value: 18000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_CA",
  //       data: [
  //         { year: 2019, value: 45000 },
  //         { year: 2020, value: 50000 },
  //         { year: 2021, value: 55000 },
  //         { year: 2022, value: 53000 },
  //         { year: 2023, value: 60000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_ASSETS",
  //       data: [
  //         { year: 2019, value: 95000 },
  //         { year: 2020, value: 110000 },
  //         { year: 2021, value: 120000 },
  //         { year: 2022, value: 125000 },
  //         { year: 2023, value: 135000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_CL",
  //       data: [
  //         { year: 2019, value: 30000 },
  //         { year: 2020, value: 35000 },
  //         { year: 2021, value: 37000 },
  //         { year: 2022, value: 40000 },
  //         { year: 2023, value: 42000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_LIAB",
  //       data: [
  //         { year: 2019, value: 55000 },
  //         { year: 2020, value: 60000 },
  //         { year: 2021, value: 65000 },
  //         { year: 2022, value: 67000 },
  //         { year: 2023, value: 70000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_EQUITY",
  //       data: [
  //         { year: 2019, value: 40000 },
  //         { year: 2020, value: 50000 },
  //         { year: 2021, value: 55000 },
  //         { year: 2022, value: 58000 },
  //         { year: 2023, value: 65000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_LIAB_EQUITY",
  //       data: [
  //         { year: 2019, value: 95000 },
  //         { year: 2020, value: 110000 },
  //         { year: 2021, value: 120000 },
  //         { year: 2022, value: 125000 },
  //         { year: 2023, value: 135000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_BV_SHARE",
  //       data: [
  //         { year: 2019, value: 25.5 },
  //         { year: 2020, value: 28.3 },
  //         { year: 2021, value: 30.1 },
  //         { year: 2022, value: 32.7 },
  //         { year: 2023, value: 34.5 },
  //       ],
  //     },
  //   ],

  //   cash_flow: [
  //     {
  //       _id: "IQ_NI_CF",
  //       data: [
  //         { year: 2019, value: 8000 },
  //         { year: 2020, value: 9500 },
  //         { year: 2021, value: 11000 },
  //         { year: 2022, value: 10500 },
  //         { year: 2023, value: 12000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_DA_CF",
  //       data: [
  //         { year: 2019, value: 2500 },
  //         { year: 2020, value: 2700 },
  //         { year: 2021, value: 2900 },
  //         { year: 2022, value: 3100 },
  //         { year: 2023, value: 3300 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CASH_OPER",
  //       data: [
  //         { year: 2019, value: 10000 },
  //         { year: 2020, value: 11500 },
  //         { year: 2021, value: 13000 },
  //         { year: 2022, value: 12800 },
  //         { year: 2023, value: 14500 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CAPEX",
  //       data: [
  //         { year: 2019, value: -4000 },
  //         { year: 2020, value: -4500 },
  //         { year: 2021, value: -5000 },
  //         { year: 2022, value: -5200 },
  //         { year: 2023, value: -5600 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CASH_INVEST",
  //       data: [
  //         { year: 2019, value: -3000 },
  //         { year: 2020, value: -3800 },
  //         { year: 2021, value: -4200 },
  //         { year: 2022, value: -4500 },
  //         { year: 2023, value: -4900 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CASH_FINAN",
  //       data: [
  //         { year: 2019, value: 1500 },
  //         { year: 2020, value: 2000 },
  //         { year: 2021, value: 2500 },
  //         { year: 2022, value: 1800 },
  //         { year: 2023, value: 2200 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_NET_CHANGE",
  //       data: [
  //         { year: 2019, value: 4500 },
  //         { year: 2020, value: 5700 },
  //         { year: 2021, value: 7300 },
  //         { year: 2022, value: 6100 },
  //         { year: 2023, value: 7800 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_UNLEVERED_FCF",
  //       data: [
  //         { year: 2019, value: 6000 },
  //         { year: 2020, value: 7000 },
  //         { year: 2021, value: 8500 },
  //         { year: 2022, value: 8200 },
  //         { year: 2023, value: 9000 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_LEVERED_CF",
  //       data: [
  //         { year: 2019, value: 5000 },
  //         { year: 2020, value: 6200 },
  //         { year: 2021, value: 7800 },
  //         { year: 2022, value: 7500 },
  //         { year: 2023, value: 8600 },
  //       ],
  //     },
  //   ],

  //   ratios: [
  //     {
  //       _id: "IQ_RETURN_ASSETS",
  //       data: [
  //         { year: 2019, value: 5.2 },
  //         { year: 2020, value: 4.8 },
  //         { year: 2021, value: 6.1 },
  //         { year: 2022, value: 5.9 },
  //         { year: 2023, value: 6.5 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_RETURN_EQUITY",
  //       data: [
  //         { year: 2019, value: 12.0 },
  //         { year: 2020, value: 10.5 },
  //         { year: 2021, value: 14.2 },
  //         { year: 2022, value: 13.8 },
  //         { year: 2023, value: 15.0 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_GROSS_MARGIN",
  //       data: [
  //         { year: 2019, value: 52.5 },
  //         { year: 2020, value: 51.8 },
  //         { year: 2021, value: 53.1 },
  //         { year: 2022, value: 54.0 },
  //         { year: 2023, value: 55.2 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_EBITDA_MARGIN",
  //       data: [
  //         { year: 2019, value: 25.1 },
  //         { year: 2020, value: 24.5 },
  //         { year: 2021, value: 26.3 },
  //         { year: 2022, value: 27.0 },
  //         { year: 2023, value: 28.2 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_NI_MARGIN",
  //       data: [
  //         { year: 2019, value: 15.2 },
  //         { year: 2020, value: 14.0 },
  //         { year: 2021, value: 16.5 },
  //         { year: 2022, value: 15.9 },
  //         { year: 2023, value: 17.1 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_CURRENT_RATIO",
  //       data: [
  //         { year: 2019, value: 1.6 },
  //         { year: 2020, value: 1.7 },
  //         { year: 2021, value: 1.8 },
  //         { year: 2022, value: 1.9 },
  //         { year: 2023, value: 2.0 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_DEBT_EQUITY",
  //       data: [
  //         { year: 2019, value: 0.45 },
  //         { year: 2020, value: 0.5 },
  //         { year: 2021, value: 0.48 },
  //         { year: 2022, value: 0.46 },
  //         { year: 2023, value: 0.44 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_DEBT_EBITDA",
  //       data: [
  //         { year: 2019, value: 2.1 },
  //         { year: 2020, value: 2.4 },
  //         { year: 2021, value: 2.2 },
  //         { year: 2022, value: 2.0 },
  //         { year: 2023, value: 1.8 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_TOTAL_REV_5YR_ANN_CAGR",
  //       data: [
  //         { year: 2019, value: 7.5 },
  //         { year: 2020, value: 8.0 },
  //         { year: 2021, value: 8.3 },
  //         { year: 2022, value: 8.7 },
  //         { year: 2023, value: 9.0 },
  //       ],
  //     },
  //     {
  //       _id: "IQ_NI_5YR_ANN_CAGR",
  //       data: [
  //         { year: 2019, value: 6.0 },
  //         { year: 2020, value: 6.5 },
  //         { year: 2021, value: 7.2 },
  //         { year: 2022, value: 7.6 },
  //         { year: 2023, value: 8.1 },
  //       ],
  //     },
  //   ],
  // };

  const decodeTab = (currentTab) => {
    switch (currentTab) {
      case "key_statistics":
        return "Key Statistics";
      case "profit_loss":
        return "Profit & Loss";
      case "balance_sheet":
        return "Balance Sheet";
      case "cash_flow":
        return "Cash Flow";
      case "ratios":
        return "Ratios";
      default:
        return "Unknown Tab";
    }
  };

  // useEffect(() => {
  //   setFinancialsDataCheck((prevState) => ({
  //     ...prevState,
  //     hasFinancialsTableData: records?.length > 0,
  //   }));

  //   dataReportCheck("financialsTable", records?.length > 0);

  // }, [records]);
  useEffect(() => {
    // +++++++++++++++++++++++++++++++++++++++++++++++++++
    const container = window;

    container.scrollTo({
      top: 0,
      behavior: "instant",
    });
    const firstKey = Object.keys(sectionMap)[0];
    setActiveSubKey(firstKey);
    // +++++++++++++++++++++++++++++++++++++++++++++++++++

    const hasRecords = hasData(records);

    setFinancialsDataCheck((prevState) => ({
      ...prevState,
      hasFinancialsTableData: hasRecords,
    }));

    // Synchronous notification to parent
    dataReportCheck("financialsTable", hasRecords);
  }, [records]);
  // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++++

  // useEffect(() => {
  //   // ++++++++++++++++++++++++++++++++++++++++++++++++
  //   const getCompanyDetails = async () => {
  //     const vendorCompanyIdLocal = getVendorCompanyId(competitorInfo);
  //     const compDetailsResponse = await getSandPCompanyDetails(
  //       vendorCompanyIdLocal
  //     );

  //     // dispatch(
  //     //   fetchReGeoWisevenueAnalysisRequest({
  //     //     ticker: compDetailsResponse?.ticker ?? "",
  //     //   })
  //     // );
  //     // dispatch(
  //     //   fetchRevenueAnalysisRequest({
  //     //     ticker: compDetailsResponse?.ticker ?? "",
  //     //   })
  //     // );

  //     //Updated according to new API response
  //     dispatch(
  //       fetchRevenueAnalysisRequest({
  //         ticker: vendorCompanyIdLocal ?? "",
  //       })
  //     );
  //   };
  //   const vendorCompanyId = getVendorCompanyId(competitorInfo);
  //   if (vendorCompanyId) getCompanyDetails();
  // }, []);
  // ++++++++++++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
  useEffect(() => {
    const tempStrategicLeadershipThemes = getAllSubdimensionMatches(
      data,
      "Strategic Themes"
    );
    setStrategicLeadershipThemes(tempStrategicLeadershipThemes);
    // const tempDynamicSubdimension = getAllDynamicSubdimensionMatches(data, [
    //   "Executive Leadership Team",
    // ]);
    // setDynamicSubdimension(tempDynamicSubdimension);

    const tempFutureBets = getAllSubdimensionMatches(data, "Future Bets");
    setFutureBets(tempFutureBets);

    // Robust checks using fresh values
    const hasFbData = hasData(tempFutureBets);
    const hasFinData = hasData(records);

    const hasStrategicThemes =
      !!tempStrategicLeadershipThemes &&
      tempStrategicLeadershipThemes.length > 0;

    setFinancialsDataCheck((prevState) => ({
      ...prevState,
      hasFutureBetsLeadershipLedInitiativesTabfData: hasFbData,
      hasFinancialsTableData: hasFinData,
      hasStrategicLeadershipThemesTabData: hasStrategicThemes,
    }));

    // Notify parent immediately using fresh local variables
    dataReportCheck("financialsTable", hasFinData);
    dataReportCheck("futureBetsLeadershipLedInitiativesTabf", hasFbData);
    dataReportCheck(
      "futureBetsLeadershipLedInitiativesTabf",
      hasStrategicThemes
    );
  }, [data]);
  // useEffect(() => {
  //   const tempFutureBets = getAllSubdimensionMatches(data, "Future Bets");
  //   setFutureBets(tempFutureBets);

  //   setFinancialsDataCheck((prevState) => ({
  //     ...prevState,
  //     hasFutureBetsLeadershipLedInitiativesTabfData: !!tempFutureBets,
  //     hasFinancialsTableData: !!(records?.length > 0),
  //   }));
  //   // console.log("FINANCIAL DATA CHECK: " + JSON.stringify(records));

  //   dataReportCheck("financialsTable", records?.length > 0);

  //   dataReportCheck(
  //     "futureBetsLeadershipLedInitiativesTabf",
  //     financialsDataCheck.hasFutureBetsLeadershipLedInitiativesTabfData
  //   );
  // }, [data]);
  // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // useEffect(() => {
  //   let subTab = decodeTab(activeTab);
  //   let userStat = getUserStatsObject(
  //     tab_name + " - " + subTab,
  //     "page_load",
  //     "Page Source: " + accountName,
  //     window.location.href,
  //     accountId
  //   );
  //   userStat.url_details = pageParsedData;
  //   recordActivity(userStat);
  // }, [activeTab]);

  const requiredValue = (value, para = "", key = "") => {
    if (value === "" || value === "Data Unavailable") {
      return <span>n.a.</span>;
    } else if (isNaN(value)) {
      return <span>-</span>;
    } else {
      let decimals = 0;
      if (para == "ratios" || key == "IQ_DILUT_EPS_INCL") {
        decimals = 2;
      }
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: decimals,
      }).format(value);
    }
  };

  // If no records are available, show a message
  // if (!recordsLoading && (!records || Object.keys(records).length === 0)) {
  //   return (
  //     <div className="">
  //       <NoDataComp
  //         message={`${
  //           account_info?.company_type?.toLowerCase().includes("private")
  //             ? "This is a private company, so detailed financials aren’t shared publicly."
  //             : "No Financials data Found"
  //         }`}
  //       />
  //       {/* <FinancialStatement /> */}

  //       <div className="org_wrapper">
  //         <div ref={futureBetsLeadershipLedInitiativesRef}>
  //           <FutureBets futureBets={futureBets?.[0]?.response?.fields || {}} />
  //         </div>
  //       </div>
  //     </div>
  //   );

  //   return null;
  // }
  // If no records are available, show a message

  // useEffect(() => {
  //   if (!records || Object.keys(records).length === 0) {
  //     setFinancialsDataCheck((prevState) => ({
  //       ...prevState,
  //       hasFinancialsTableData: !!records,
  //     }));

  //     dataReportCheck(
  //       "financialsTable",
  //       financialsDataCheck.hasFinancialsTableData
  //     );

  //     // return null;
  //   }
  // }, [records]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -35;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 120; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("⏳ Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps

  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 10); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  // useEffect(() => {
  //   const container = scrollContainerRef?.current || window;

  //   container.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div>
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* STRATEGIC LEADERSHIP THEMES FROM ORG STRUCTURE SUBDIMENSION */}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : subdimensionExists("Strategic_Themes") &&
        subdimensionEnabled("Strategic_Themes") &&
        financialsDataCheck.hasStrategicLeadershipThemesTabData ? (
        <div ref={strategicLeadershipThemesRef}>
          <StrategicLeadershipThemes
            strategicLeadershipThemes={strategicLeadershipThemes}
          />
        </div>
      ) : null}
      {/* STRATEGIC LEADERSHIP THEMES FROM ORG STRUCTURE SUBDIMENSION */}

      {/* REVENUE ANALYSIS */}
      <RevenueAnalysis />
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++ */}

      <div ref={financialTablesRef}>
        {recordsLoading && Object.keys(records).length < 1 ? (
          <GenericTableSkeleton rowCount={10} colCount={6} />
        ) : (
          // !recordsLoading &&
          //   (!records || Object.keys(records).length === 0) ? (
          //   <div className="">
          //     <NoDataComp
          //       message={`${
          //         account_info?.company_type?.toLowerCase().includes("private")
          //           ? "This is a private company, so detailed financials aren’t shared publicly."
          //           : "No Financials data Found"
          //       }`}
          //     />
          //     {/* <FinancialStatement /> */}
          //   </div>
          // ) :
          !recordsLoading &&
          financialsDataCheck.hasFinancialsTableData && (
            <>
              <div className="financials_wrapper">
                <FinancialTabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />

                <div className="">
                  {activeTab === "key_statistics" && (
                    <KeyStatistics
                      records={records}
                      requiredValue={requiredValue}
                    />
                  )}

                  {activeTab === "profit_loss" && (
                    <IncomeStatement
                      records={records}
                      requiredValue={requiredValue}
                    />
                  )}

                  {activeTab === "balance_sheet" && (
                    <BalanceSheet
                      records={records}
                      requiredValue={requiredValue}
                    />
                  )}

                  {activeTab === "cash_flow" && (
                    <CashFlow records={records} requiredValue={requiredValue} />
                  )}

                  {activeTab === "ratios" && (
                    <Ratios records={records} requiredValue={requiredValue} />
                  )}
                </div>
              </div>
            </>
          )
        )}
      </div>

      <div
        className={financialsDataCheck.hasFinancialsTableData ? "mt-5" : ""}
        ref={futureBetsLeadershipLedInitiativesFRef}
      >
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          financialsDataCheck.hasFutureBetsLeadershipLedInitiativesTabfData && (
            <div className="org_wrapper p-0 mt-4">
              <div>
                <FutureBets
                  futureBets={futureBets?.[0]?.response?.fields || {}}
                />
              </div>
            </div>
          )
        )}
      </div>

      {/* {financialsDataCheck.hasFinancialDocumentsData && ( */}
      {
        // In the JSX, your ref should look like this to maintain scroll integrity
        <div
          ref={financialDocumentsRef}
          style={{
            display: financialsDataCheck.hasFinancialDocumentsData
              ? "block"
              : "none",
          }}
        >
          <DocumentsV3
            competitorInfo={competitorInfo}
            financialsDataCheck={financialsDataCheck}
            setFinancialsDataCheck={setFinancialsDataCheck}
            dataReportCheck={dataReportCheck}
          />
        </div>
        // <div className="" ref={financialDocumentsRef}>
        //   <DocumentsV3
        //     competitorInfo={competitorInfo}
        //     financialsDataCheck={financialsDataCheck}
        //     setFinancialsDataCheck={setFinancialsDataCheck}
        //     dataReportCheck={dataReportCheck}
        //   />
        // </div>
      }

      {/* {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_financials_${index}`;

        return (
          <div key={key} ref={(el) => (dynamicRefs.current[key] = el)}>
            <h5 className="mb-4">
              {item?.response?.subdimension_name}
              <span className="dynamic-subdimension-label">
                (User generated table)
              </span>
            </h5>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })} */}

      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp />
        </button>
      )}
    </div>
  );
}
